
<template>
  <el-select
    class="tm-select"
    :class="{ 'filter-select': isFilter }"
    :style="{ width: width ? width + 'px' : '' }"
    :placeholder="placeholder"
    v-model.lazy="value"
    ref="select"
    v-bind="attrs"
    :suffix-icon="isFilter ? CaretBottom : ArrowDown"
    popper-class="eloption"
  >
    <el-option v-for="(item, i) in options" :key="i" :label="item[name]" :value="item[key]">
    </el-option>
  </el-select>
</template>
<script>
import { reactive, toRefs, onMounted, ref } from 'vue';
import { CaretBottom, ArrowDown } from '@element-plus/icons-vue';
export default {
  name: 'TmSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    // 选项
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 选中的值
    data: {
      type: [String, Number],
      requred: true,
    },
    placeholder: {
      type: String,
      defalut: '请选择',
    },
    keyValue: {
      type: [String, Number],
    },
    nameValue: {
      type: String,
    },
    width: {
      type: [String, Number],
      default: 130,
    },
    isFilter: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { attrs }) {
    const { options } = toRefs(props);
    const state = reactive({
      value: props.data || '',
      key: props.keyValue || 'value',
      name: props.nameValue || 'name',
      options,
    });
    const select = ref(null)
    onMounted(() => {});
    return {
      ...toRefs(state),
      attrs,
      CaretBottom,
      ArrowDown,
      select
    };
  },
};
</script>
<style lang="less" scoped>
.filter-select.el-select {
  line-height: 30px;
  :deep(.el-input__inner) {
    border-radius: 0;
    border-color: #979797;
    color: @themeFontColor;
    &::-webkit-input-placeholder {
      color: @themeFontColor;
    }
  }
  :deep(.el-input__icon) {
    color: #000;
  }
  :deep(.el-select__icon) {
    color: @themeFontColor;
    margin-left: 0;
  }
}
</style>
